import type { Show } from '../api/types'
import { useUploadArtwork } from '../hooks/useShows'
import { Card, CopyField, ErrorNote } from './ui'

/** A show's feed, public page and artwork: what podcast directories need. */
export function ShowPublishing({ workspaceId, show, canEdit }: { workspaceId: string; show: Show; canEdit: boolean }) {
  const upload = useUploadArtwork(workspaceId, show.id)
  return (
    <Card title="Podcast feed">
      <div className="publishing">
        <div className="stack-sm artwork-box">
          {show.artwork_url ? <img className="artwork" src={show.artwork_url} alt="Show artwork" /> : <div className="artwork artwork-empty">No artwork</div>}
          {canEdit && (
            <label className={`btn btn-secondary${upload.isPending ? ' is-busy' : ''}`}>
              {upload.isPending ? 'Uploading…' : show.artwork_url ? 'Replace artwork' : 'Upload artwork'}
              <input
                type="file"
                accept="image/png,image/jpeg"
                hidden
                onChange={(event) => {
                  const file = event.target.files?.[0]
                  if (file) upload.mutate(file)
                  event.target.value = ''
                }}
              />
            </label>
          )}
          <span className="muted small">Square JPEG or PNG, 1400 to 3000 pixels.</span>
        </div>
        <div className="stack">
          <CopyField label="RSS feed" value={show.feed_url} />
          {show.published_episodes > 0 ? (
            <a href={show.page_url} target="_blank" rel="noopener noreferrer">
              Open the public page ↗
            </a>
          ) : (
            <p className="muted small">The public page opens once an episode is published.</p>
          )}
          {(!show.owner_email || !show.artwork_url || !show.category) && (
            <p className="muted small">
              Apple Podcasts and Spotify want artwork, a category and an owner email before they list a show. Add the details in Edit show.
            </p>
          )}
          {show.import_url && <p className="muted small">Imported from {show.import_url}. Importing it again adds new episodes.</p>}
          {upload.error && <ErrorNote error={upload.error} />}
        </div>
      </div>
    </Card>
  )
}
